import { webRequestClient } from '@/services'
import { errorHandler } from '@/utils/helpers'

export default {
    /**
     * Get metrics for a formule and store it.
     * @param {Object} context vuex context
     * @param {Object} payload
     * @param {String} payload.type Type of metrics 'Volumes', 'Summary'
     * @param {Object} payload.formula formula in V2 format
     * @param {Number} payload.tryCounter
     */
    async getFormulaMetrics({ commit, dispatch, rootState, state }, { type, formula, tryCounter = 0 }) {

        const time = Date.now()
        const loadingKey = `formula${type}Loading`
        const loadingMutationName = `setBuilderFormula${type}Loading`
        commit(loadingMutationName, time)

        const params = {
            account_id: rootState.account.accountId,
            formula: type === 'Volumes' ? formula.v2 : formula.v1,
            method: type === 'Volumes' ? 'count': type.toLowerCase(),
            version: type === 'Volumes' ? 2 : 1
        }

        try {
            const res = await webRequestClient.post('/audience_admin/criteria/statistic.json', params)

            if (res.status === 'NOT_READY') {
                if (tryCounter < 30) {
                    setTimeout(() => {
                        dispatch('getFormulaMetrics', { type, formula, tryCounter: tryCounter + 1 })
                    }, 1000)
                } else {
                    if (state[loadingKey] == time) {
                        commit(loadingMutationName, false)
                        errorHandler(`Unable to retrieve ${type}`, commit)
                    }
                }
            } else {
                if (state[loadingKey] == time) {
                    commit(`setBuilderFormula${type}`, res)
                    commit(loadingMutationName, false)
                }
            }

        } catch(_err) {
            if (state[loadingKey] == time) {
                const errorAuthorization = [
                    '"breakdown.v1: Access forbidden: this account isn\'t authorized to access to Breakdown"',
                    '"breakdown.v1: Access forbidden: this account isn\'t authorized to access to Breakdown Bigsea Sociodemo and Bigsea Behavioral"'
                ]
                commit(loadingMutationName, false)
                if(!errorAuthorization.includes(_err.apiError?.message)) {
                    errorHandler(`Unable to retrieve ${type}`, commit)
                }
            }
        }
    }
}
